import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reason", "description", "descriptionWrap"]
  static values = { other: { type: String, default: "other" } }

  connect() {
    this.syncDescription()
  }

  changed() {
    this.syncDescription()
  }

  syncDescription() {
    const isOther = this.hasReasonTarget && this.reasonTarget.value === this.otherValue
    if (this.hasDescriptionWrapTarget) {
      this.descriptionWrapTarget.classList.toggle("hidden", !isOther)
    }
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.required = isOther
      if (!isOther) {
        this.descriptionTarget.value = ""
      }
    }
  }
}
